export default "__VITE_ASSET__2Sm75$PI__"